export const LOAD_LINE_MANAGERS_SUCCESS = "LOAD_LINE_MANAGERS_SUCCESS";

export const LOAD_RECRUITMENT_MANAGERS_SUCCESS = "LOAD_RECRUITMENT_MANAGERS_SUCCESS";

export const LINE_MANAGER_SELECTED = "LINE_MANAGER_SELECTED";

export const LOAD_HR_REPRESENTATIVES_SUCCESS = "LOAD_HR_REPRESENTATIVES_SUCCESS";

export const HR_REPRESENTATIVE_SELECTED = "HR_REPRESENTATIVE_SELECTED";

export const LOAD_ORG_STRUCTURES_SUCCESS = "LOAD_ORG_STRUCTURES_SUCCESS";

export const CLEAR_ORG_STRUCTURES = "CLEAR_ORG_STRUCTURES";

export const AUTO_SAVE_REFERRAL_FORM = "AUTO_SAVE_REFERRAL_FORM";

export const AUTO_SAVE_REFERRAL_FORM_SUCCESS = "AUTO_SAVE_REFERRAL_FORM_SUCCESS";

export const SUBMIT_REFERRAL_FORM = "SUBMIT_REFERRAL_FORM";
